import cloneDeep from 'lodash/cloneDeep'
import ListFactory from '.'
import {generateForm} from '../../components/FormTpl'
import parseRules from '../../utils/parseRules'
import ColumnEditModal from './column-edit-modal'
import FormTpl from '../../components/FormTpl/index'

import EmbedAdd from './add/embedAdd'
import mapSchemas from '../../utils/mapSchemas'
import {formatParams} from '../../utils/params'
import {getTableVNode, getPaginationVNode} from '../common/vnode'
import {parseActions} from '../common/dataParse'
import {checkPerm} from '../../helper/permission'
import { MODE } from '../../constant'
import SpSelect from '../../components/Forms/SpSelect.vue'
import eventHub from '../../utils/eventHub'

export default {
  name: 'List',
  components: { SpSelect },
  render(h) {
    const searchChildren = []
    if (this.tabSchema.length === 1) {
      let { items } = this.tabSchema[0]
      if (typeof items === 'function') {
        items = items(this.$store.state)
      }
      searchChildren.push((
        <el-tabs
          value={this.searchFormData[this.tabSchema[0].key]}
          on-input={val => this.searchFormData[this.tabSchema[0].key] = val}
          on-tab-click={this.onTabSwitch}
        >
          {
            items.map(option => (
              <el-tab-pane
                label={this.$i18n(option.label)}
                name={String(option.value)}
              />
            ))
          }
        </el-tabs>
      ))
    }
    if (this.filterSchema.length) {
      searchChildren.push((
        <FormTpl
          model={this.searchFormData}
          fields={this.filterSchema}
          options={{ inline: true, noValidate: true }}
          on-searchForm={this.onSearch}
        >
          <el-form-item>
            <el-button
              nativeType="reset"
              on-click={this.onReset}
            >
              {this.$i18n('Reset')}
            </el-button>
            <el-button
              type="primary"
              nativeType="submit"
              on-click={this.onSearch}
            >
              {this.$i18n('Search')}
            </el-button>
          </el-form-item>
        </FormTpl>
      ))
    }
    if (this.$slots.customForm) {
      searchChildren.push(...this.$slots.customForm)
    }

    const btnsChildren = []
    if (!this.options || !this.options.hideCreateButton) {
      btnsChildren.push(
        <el-button type="primary" on-click={this.addHandler}>
          {this.$i18n(`Create ${this.data.resourceName}`)}
        </el-button>
      )
    }
    if (this.hooks && Array.isArray(this.hooks)) {
      btnsChildren.push(...this.hooks.map(hook => {
        const options = hook.options || {}
        if (options.checkPerm && !checkPerm(this.$store, options.checkPerm)) {
          return null
        }
        // TODO: re-design this hook
        let handler = hook.handler
        if (hook.type === 'export' && options.editColumn) {
          handler = () => this.openedModal = 'export'
          this.exportHandler = hook.handler
        }
        return (
          <el-button on-click={() => handler.call(this)}>
            {this.$i18n(hook.label)}
          </el-button>
        )
      }))
    }

    const table = this.tableVisible ? getTableVNode(this, h) : null

    const columnEditButton = (
      <el-button
        class="sp-column-edit-button"
        type="info"
        size="mini"
        plain
        on-click={() => this.openedModal = 'table-column-edit'}
      >
        <i class="el-icon-sort"></i>
      </el-button>
    )

    const dataDisplayArea = generateForm(h, {},
      this.inTableEditData[this.inTableEditRowId] || {},
      parseRules({ fields: this.tableSchema }),
      [
        <div style={{ position: 'relative' }}>
          {table}
          {(this.options && this.options.columnEditable) ? columnEditButton : null}
        </div>
      ]
    )

    return (
      <div>
        <div class="sp-card core-container">{searchChildren}</div>
        <div class="sp-card main-container">
          <div class="sp-hooks">{btnsChildren}</div>
          <el-collapse-transition>
            {this.renderEmbedAdd(h)}
          </el-collapse-transition>
          {dataDisplayArea}
          {getPaginationVNode(this, h)}
        </div>
        {this.renderModal(h, this.openedModal)}
      </div>
    )
  },
  props: ['mode', 'data', 'schema', 'actions', 'hooks', 'options', 'resourceType'],
  data () {
    return {
      searchFormData: {},
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      parsedActions: [],
      inTableAdd: false,
      inTableEditMode: {},
      inTableEditData: {},
      inTableEditRowId: 0,
      openedModal: null,
      pickedColumns: [],
      tempSchema: 'sku_location',
      tableVisible: true,
      exportHandler: () => {},
      confirmText: this.$i18n('Confirm ?')
    }
  },
  computed: {
    ...mapSchemas(),
    tableData () {
      return this.data.provider.list(this.$store.state)
    }
  },
  created() {
    if (this.tabSchema.length === 1) {
      let { items } = this.tabSchema[0]
      if (typeof items === 'function') {
        items = items(this.$store.state)
      }
      if (items && items.length) {
        this.searchFormData[this.tabSchema[0].key] = String(items[0].value)
      }
    }
    if (this.resourceType !== 'main') {
      for (const schema of this.hiddenSchema) {
        this.searchFormData[schema.key] = this.$route.query[schema.key]
      }
    }
    this.pickedColumns = this.schema.filter(item => item.inTable).map(t => ({
      id: t.key,
      label: this.$i18n(t.label),
      visible: true
    }))
    if (this.$route.params.view === 'edit' || this.$route.params.view === 'detail') {
      this.$emit('triggerFetchOne', this.$route.query)
    }
    this.parsedActions = parseActions(this, this.actions)
    this.onSearch()
    eventHub.$on(`${this.data.name}listOnSearch`, this.onSearch)
  },
  beforeDestroy() {
    eventHub.$off(`${this.data.name}listOnSearch`, this.onSearch)
  },
  methods: {
    onSearch (event, extraParams = {}) {
      this.currentPage = 1
      event && typeof event === 'object' && event.preventDefault()
      const params = formatParams(this.searchFormData, extraParams)
      this.$emit('triggerSearch', params)
    },
    onReset () {
      this.filterSchema.forEach(item => {
        this.searchFormData[item.key] = item.options.defaultValue
      })
    },
    onTabSwitch (tab) {
      this.onReset()
      this.onSearch()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
      this.$emit('triggerSearch', {
        ...formatParams(this.searchFormData),
        // DEPRECATED: remove a key
        page: this.currentPage,
        pageno: this.currentPage,
        count: this.pageSize
      })
    },
    handleCurrentChange (page) {
      this.currentPage = page
      this.$emit('triggerSearch', {
        ...formatParams(this.searchFormData),
        // DEPRECATED: remove a key
        page: this.currentPage,
        pageno: this.currentPage,
        count: this.pageSize
      })
    },
    addHandler() {
      if (this.mode === MODE.EDIT_IN_TABLE) {
        this.inTableAdd = true
      } else {
        this.$emit('addHandle')
      }
    },
    deleteHandler(index, row) {
      this.$confirm(this.confirmText).then(() => this.$emit('triggerDelete', {
        data: {
          id: row.id
        },
        // TODO: move 'fetch' action to store
        cb: () => this.onSearch()
      }))
    },
    editHandler(index, row) {
      switch (this.$props.mode) {
        case MODE.EDIT_IN_TABLE:
          this.$set(this.inTableEditData, row.id, {})
          for (const schema of this.tableSchema) {
            if (schema.editable) {
              this.inTableEditRowId = row.id
              this.$set(this.inTableEditData[row.id], schema.key, cloneDeep(row[schema.key]))
            }
          }
          this.$set(this.inTableEditMode, row.id, !this.inTableEditMode[row.id])
          break
        case MODE.EDIT_IN_DIALOG: {
          const params = this.hiddenSchema.reduce((obj, schema) => ({
            ...obj,
            [schema.key]: row[schema.key]
          }), {})
          this.$emit('triggerFetchOne', params)
          this.$emit('editHandle', params)
          break
        }
        case MODE.EDIT_IN_NEW_PAGE: {
          const params = this.hiddenSchema.reduce((obj, schema) => ({
            ...obj,
            [schema.key]: row[schema.key]
          }), {})
          this.$emit('editHandle', params)
          break
        }
      }
    },
    detailHandler(index, row) {
      const params = this.hiddenSchema.reduce((obj, schema) => ({
        ...obj,
        [schema.key]: row[schema.key]
      }), {})
      this.$emit('triggerFetchOne', params)
      this.$emit('detailHandle', params)
    },
    renderModal(h, openedModal) {
      switch (openedModal) {
        case 'table-column-edit':
          return (
            <ColumnEditModal
              schema={this.pickedColumns}
              handleConfirm={columns => {
                this.pickedColumns = columns
                // due to element's table bug, we must re-render
                this.tableVisible = false
                this.$nextTick(() => this.tableVisible = true)
              }}
              handleCancel={() => this.openedModal = null}
            />
          )
        case 'export':
          // DEPRECATED: finish this!
          return (
            <ColumnEditModal
              schema={this.tempSchema === 'uid' ? [] : this.pickedColumns}
              tempSchema={this.tempSchema}
              handleConfirm={columns => {
                this.exportHandler(columns, formatParams(this.searchFormData))
              }}
              handleCancel={() => this.openedModal = null}
              on-updateTempSchema={value => this.tempSchema = value}
            />
          )
      }
      return null
    },
    renderEmbedAdd(h) {
      if (this.mode === MODE.EDIT_IN_TABLE && this.inTableAdd) {
        return (
          <EmbedAdd
            schema={this.schema}
            data={this.data}
            close={() => this.inTableAdd = false}
          />
        )
      }
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./packages/creator/ListView/list.js